import { Popover } from '@mui/material';
import { styled } from '@mui/material/styles';

const PeekPopover = styled(Popover)(({ theme }) => ({}));

export { PeekPopover, PeekPopover as default };
